import {SiteModel} from "../../../core/_models";
import {FC} from "react";

type Props = {
  site: SiteModel
}
const SiteNameCell: FC<Props> = ({site}) => (

  <div className='d-flex align-items-center'>
    <span>{site.buildingName}</span>
  </div>

)
export { SiteNameCell }